import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Form, Button } from 'react-bootstrap'
import PropTypes from 'prop-types'
import t from '../../service/translate.service'
import PrimaryTitle from '../../components/PrimaryTitle'
import LoyaltyPaymentCashOut from './LoyaltyPaymentCashOut'
import LoyaltyPaymentDeposit from './LoyaltyPaymentDeposit'
import LoyaltyPaymentKeepPoints from './LoyaltyPaymentKeepPoints'
import { extendObservable } from 'mobx'

class LoyaltyPaymentInitialMessage extends Component {

  constructor(props) {
    super(props)
    extendObservable(this, {
     verificationStarted: false
    })
  
  }
  componentDidMount = () => {
    window.scrollTo(0, 0)
  }

  handleCashOut = () => {
    this.props.store.cashOut = true
  }
  handleDeposit = () => {
    this.props.store.deposit = true
  }
  handleKeepPoints = () => {
    this.props.store.keepPoints = true
  }
  OnCancelLoyaltyPayment = () => {
    this.props.store.loyaltyPayment = false
  }
  onCancelCashOut = () => {
    this.props.store.cashOut = false
    this.props.store.iban = ''
    this.props.store.confirmIban = false
    this.props.store.email = ''
    this.props.store.password = ''
    this.props.store.cashOutError = ''
  }
  onCancelDeposit = () => {
    this.props.store.deposit = false
  }
  onCancelKeepPoints = () => {
    this.props.store.keepPoints = false
  }
  backToLoyalty = () => {
    this.props.store.loyaltyPayment = false
    this.props.store.keepPoints = false
  }
  goBack = () => {
    this.props.navigate(-2)
  }

  startVerificationProcess = () => {
    this.verificationStarted = true
  }

  render() {
    const { store, verificationEnabled, contractVerified } = this.props
    const { cashOut, deposit, keepPoints, redeemPoints, pointsToEuro } = store
    if (cashOut) {
      return (
        <LoyaltyPaymentCashOut
          store={store}
          onCancel={this.onCancelCashOut}
          onRedeem={redeemPoints}
          goBack={this.goBack}
          verificationEnabled={verificationEnabled}
          contractVerified={contractVerified}
        />
      )
    }

    if (deposit) {
      return (
        <LoyaltyPaymentDeposit
          store={store}
          onCancel={this.onCancelDeposit}
        />
      )
    }

    if (keepPoints) {
      return (
        <LoyaltyPaymentKeepPoints
          store={store}
          onCancel={this.onCancelKeepPoints}
          backToLoyalty={this.backToLoyalty}
        />
      )
    }

    return (
      
      <div className='loyalty-upload module'>
        <div className='loyalty-code-top text-center'>
          <PrimaryTitle title={t.LOYALTY_INITIAL_MESSAGE_TITLE} />
          <p>{t.LOYALTY_INITIAL_MESSAGE_TEXT1 + pointsToEuro.toFixed(2).replace('.', ',') + t.LOYALTY_INITIAL_MESSAGE_TEXT2}</p>
          <p>{t.LOYALTY_INITIAL_MESSAGE_TEXT3}</p>
        </div>
        <Form>
          <Form.Group className='actions text-center'>
            <div className='group'>
              <p style={{ marginBottom: '10px' }}>{t.LOYALTY_INITIAL_MESSAGE_TEXT4}</p>
              <a
                href=''
                onClick={(e) => {
                  if (e.key !== 'Tab') {
                    e.preventDefault()
                  }
                  this.handleCashOut(e)
                }}
                className='button primary'
                style={{
                  textDecoration: 'none',
                  color: 'unset',
                  marginBottom: '20px'
                }}
              >
                {t.LOYALTY_INITIAL_MESSAGE_BTN1}
              </a>
              {/* <Button className='button primary' onClick={this.handleDeposit}>{t.LOYALTY_INITIAL_MESSAGE_BTN2}</Button> */}
              <a
                href=''
                onClick={(e) => {
                  if (e.key !== 'Tab') {
                    e.preventDefault()
                  }
                  this.handleKeepPoints(e)
                }}
                className='button primary'
                style={{
                  textDecoration: 'none',
                  color: 'unset',
                  marginBottom: '20px'
                }}
              >
                {t.LOYALTY_INITIAL_MESSAGE_BTN3}
              </a>
            </div>
          </Form.Group>
        </Form>
          <a
            href=''
            onClick={(e) => {
              if (e.key !== 'Tab') {
                e.preventDefault()
              }
              this.OnCancelLoyaltyPayment(e)
            }}
            className='button tertiary'
            style={{
              textDecoration: 'none',
              color: 'unset'
            }}
          >
            {t.FORM_CANCEL}
          </a>
      </div>
    )
  }
}

LoyaltyPaymentInitialMessage.propTypes = {
  store: PropTypes.object,
  verificationEnabled: PropTypes.bool,
  userVerified: PropTypes.bool,
  contractVerified: PropTypes.bool
}

export default observer(LoyaltyPaymentInitialMessage)
